// California's own layer (CAL FIRE, BCDC, HCD, MTC) as a few tiles: what the national sites don't show. One list and one
// wording for the market page's card, the panel's California card and California areas' emails.
import { CALIFORNIA } from "./regions.ts";
import { fmt, metricPeriod, zipOrigin } from "./format.ts";
import type { MetricDef } from "./types.ts";

/** The tiles, in order; a tile is left out where the area has no value. */
export const CA_TILES = ["fire_high_pct", "slr_flood_2050_pct", "homes_permitted_per_1k", "homes_entitled_per_1k", "rhna_pace", "sb79_zone_pct"];
export const CA_HEADING = "California: risk and building";
export const CA_SOURCES = "Fire hazard zones (CAL FIRE), sea-level-rise flooding by 2050 (BCDC), homes permitted and approved and progress on the state housing target (HCD), and SB 79 transit zones, where apartments are now allowed (MTC, Bay Area).";
export const CA_INSURANCE = "In a high fire hazard or sea-level-rise zone, insurance can cost far more than the area's average: get quotes before you offer.";

export interface CaArea {
  geo_id: string;
  level: string;
  parents: Array<{ geo_id: string }>;
  /** a metro's main state (its OMB title's first): metros have no parents */
  main_state?: string | null;
  latest: Record<string, { period: string; value: number } | undefined>;
  from_zips?: string[] | null;
  partly_zips?: string[] | null;
  zip_rough?: boolean;
}

export const isCaArea = (a: Pick<CaArea, "geo_id" | "parents" | "main_state">) =>
  a.geo_id === CALIFORNIA.geoId || a.parents.some((p) => p.geo_id === CALIFORNIA.geoId) || a.main_state === CALIFORNIA.geoId;

export interface CaTile { id: string; label: string; value: string; /** when (a year or month; nothing for a map layer), and "from its ZIPs" for a city */ sub: string }

/** The area's California tiles; none outside California. */
export function caTiles(a: CaArea, def: (id: string) => Pick<MetricDef, "label" | "unit" | "cadence" | "source"> | undefined): CaTile[] {
  if (!isCaArea(a)) return [];
  return CA_TILES.flatMap((id) => {
    const d = def(id), v = a.latest[id];
    if (!d || !v) return [];
    // when: the year for yearly data, nothing for a static map layer
    const when = d.cadence === "static" ? "" : metricPeriod(d, v.period);
    return [{ id, label: d.label, value: fmt(d, v.value), sub: [when, zipOrigin(a, id)?.label ?? ""].filter(Boolean).join(" · ") }];
  });
}
